import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", {
      class: _normalizeClass(["dropdown-menu suggestion-box", { show: _ctx.showSuggestionBox }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestions, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item,
          class: _normalizeClass({ active: index === _ctx.highlightedIndex }),
          onClick: ($event: any) => (_ctx.SelectItem(item))
        }, [
          _createElementVNode("a", null, _toDisplayString(item), 1)
        ], 10, _hoisted_1))
      }), 128))
    ], 2)
  ]))
}